import { c as _c } from "react/compiler-runtime";
import { useLocale, useTranslations } from 'next-intl';
import { ChevronRightIcon, SearchIcon } from 'lucide-react';
import { InputGroup, InputGroupAddon, InputGroupInput } from '@/components/ui/input-group';
import { Button } from '@/components/ui/button';
type PropsType = {
  route: string;
  mobile?: boolean;
  className?: string;
};
const TopSearchBar = t0 => {
  const $ = _c(21);
  const {
    route,
    mobile: t1,
    className: t2
  } = t0;
  const mobile = t1 === undefined ? false : t1;
  const className = t2 === undefined ? "" : t2;
  const t = useTranslations();
  const locale = useLocale();
  const t3 = `/${locale}${route}`;
  const t4 = `${mobile ? "bg-gray-400" : "bg-white"} z-0 h-8 rounded-none border-0 text-gray-900 shadow-none has-[[data-slot=input-group-control]:focus-visible]:ring-1 ${className}`;
  let t5;
  if ($[0] !== t) {
    t5 = t("search_keyword");
    $[0] = t;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = `h-8 text-sm ${mobile ? "text-white placeholder:text-gray-300" : "text-gray-900 placeholder:text-gray-400"}`;
  let t7;
  if ($[2] !== t5 || $[3] !== t6) {
    t7 = <InputGroupInput type="search" autoComplete="off" name="q" placeholder={t5} suppressHydrationWarning={true} className={t6} />;
    $[2] = t5;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const t8 = `rounded-none ${mobile ? "text-gray-600" : "text-gray-400"}`;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SearchIcon className="h-4 w-4" />;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== t8) {
    t10 = <InputGroupAddon className={t8}>{t9}</InputGroupAddon>;
    $[6] = t8;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== t10 || $[9] !== t4 || $[10] !== t7) {
    t11 = <InputGroup className={t4}>{t7}{t10}</InputGroup>;
    $[8] = t10;
    $[9] = t4;
    $[10] = t7;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t) {
    t12 = t("search_go");
    $[12] = t;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ChevronRightIcon className="h-4 w-4" />;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t12) {
    t14 = <Button size="sm" variant="default" className="z-10 h-8 gap-1 rounded-none bg-gray-700 px-3 text-center text-sm text-white uppercase hover:bg-gray-800">{t12}{t13}</Button>;
    $[15] = t12;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== t11 || $[18] !== t14 || $[19] !== t3) {
    t15 = <form method="get" action={t3} className="flex flex-row transition-all duration-300 ease-in-out lg:w-[80%] xl:w-[85%] 2xl:w-full">{t11}{t14}</form>;
    $[17] = t11;
    $[18] = t14;
    $[19] = t3;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  return t15;
};
export default TopSearchBar;